'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/manage-catalogs-item.hbs');

var ManageCatalogsItemView = ItemView.extend({
    template: template,

    tagName: 'li',

    className: 'box',

    attributes: {
        'data-mode': 'view',
    },

    'ui': {
        form: 'form',
        buttonShowEditForm: '[data-action="show-edit-form"]',
        buttonHideEditForm: '[data-action="hide-edit-form"]',
        deleteCatalog: '[data-action="delete-catalog"]',
        inputCatalogName: '[name="catalog-name"]',
        catalogFormSubmit: '[type="submit"]',
    },

    events: {
        'click @ui.buttonShowEditForm': 'showEditForm',
        'click @ui.buttonHideEditForm': 'hideEditForm',

        'click @ui.deleteCatalog': 'deleteCatalog',
        'submit @ui.form': 'updateCatalog',
        'input @ui.inputCatalogName': 'checkSubmitButton',
    },

    modelEvents: {
        'change': 'render',
    },

    showEditForm: function() {
        this.$el.attr('data-mode', 'edit');
        this.ui.inputCatalogName.focus();
    },

    hideEditForm: function() {
        this.$el.attr('data-mode', 'view');
    },

    checkSubmitButton: function() {
        var hasName = this.ui.inputCatalogName.val().trim();

        this.ui.catalogFormSubmit.prop('disabled', !hasName);
    },

    updateCatalog: function (event) {
        event ? event.preventDefault() : null;

        this.model.save({
            name: this.ui.inputCatalogName.val().trim(),
        }, {
            patch: true,
            success: function (model) {
                this.hideEditForm();

                Messenger().success({
                    message: App.t('settings::catalogs:update:messages-success', {catalogName: model.get('name')}),
                    hideAfter: 5,
                });
            }.bind(this),

            error: function () {
                Messenger().error({
                    message: App.t('settings::catalogs:update:messages-error'),
                });
            },
        })
    },

    deleteCatalog: function () {
        if (!window.confirm(App.t('settings::catalogs:delete:message-confirm', {catalogName: this.model.get('name')}))) {
            return;
        }

        this.model.destroy({
            success: function(model) {
                Messenger().success({
                    message: App.t('settings::catalogs:delete:messages-success', {catalogName: model.get('name')}),
                    hideAfter: 5,
                });
            },
            error: function() {
                Messenger().error({
                    message: App.t('settings::catalogs:delete:messages-error'),
                });
            },
        });
    },

    viewData: {
        typeName: function() { return App.t('settings::catalogs:type:' + this.model.get('type')); },
        catalogUrl: function() { return '/catalogs/' + this.model.get('id'); },
    },
});

module.exports = ManageCatalogsItemView;